import { FileTextOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { useState } from 'react';

import { getDocumentFlowAccess } from '@app/access/utils';
import { config } from '@app/config';
import { useUserPrint } from '@app/hooks';
import { IframePage } from '@app/pages/IframePage';

import type { RecordDocumentsProps } from '../types';

import '@app/components/RecordModal/components/ClientData/components/RecordDocuments/styles/RecordDocuments.desktop.scss';

const PF = 'record-documents';

export const RecordDocuments = ({ recordId }: RecordDocumentsProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { database } = useUserPrint();

  if (!getDocumentFlowAccess(database) || !recordId) return null;

  return (
    <>
      <Button
        icon={<FileTextOutlined />}
        onClick={() => setIsOpen(true)}
        data-testid="record-documents"
      >
        Документы
      </Button>
      <Modal
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        title="Документы"
        footer={null}
        width="90vw"
        className={`${PF}__modal`}
        destroyOnHidden
      >
        {/* Филиал не передаём: у записи он всегда активный, IframePage
            подставит его сам. */}
        <IframePage
          host={config.documentFlowHost}
          recordId={recordId}
          isEmbedded
        />
      </Modal>
    </>
  );
};
